import { useNavigate } from 'react-router-dom';

export default function Error404Page() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center h-screen">
      <div
        className="
        px-10 pt-14 pb-10
        text-center rounded-xl bg-[#202020]
        select-none
        "
      >
        <h1 className="mb-6 text-9xl font-semibold text-gray-300">404</h1>
        <p className="text-2xl font-semibold text-gray-300 ">Oops! Page not found</p>
        <p className="mt-2 text-gray-500">The page you are looking for does not exist</p>
        <button
          className="
          w-full
          mt-6 p-4
          inline-block rounded-lg
          bg-indigo-500 hover:bg-indigo-700
          text-white
          "
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    </div>
  );
}
